// Connector falls back to globalThis.fetch when this is undefined.
// Do not import react-native-nitro-fetch here — its native entry pulls in
// web-streams-polyfill, which breaks Expo web SSR (fetch-nodeshim + undici).
export default undefined;
